export const ORDERS_FETCHED = "SellOrdersScreen/ORDERS_FETCHED";
export const ORDERS_CONSTANTS_FETCHED = "SellOrdersScreen/ORDERS_CONSTANTS_FETCHED";